const getProductSku = item => {
  const itemNumber = item?.itemNumber || item?.item_number;
  const skuParts = itemNumber ? itemNumber.split('-') : [];
  return itemNumber ? `${skuParts[0]}-${skuParts[1]}` : '';
};

export default getProductSku;
